$(function () {
	$('.base__btn--black').on('click', function () {
		$(this).parents('.base__header').next('.base__content').addClass('show');
		$(this).addClass('hide');
	});

	$('.flow__header').on('click', function () {
		$(this).next('.flow__detail').addClass('show');
	});

	$('.tab__listItem--leaveJa').on('click', function () {
		$('.tab__listItem').removeClass('active');
		$(this).addClass('active');
		$('.toJa').removeClass('show');
		$('.leaveJa').addClass('show');
	});

	$('.tab__listItem--toJa').on('click', function () {
		$('.tab__listItem').removeClass('active');
		$(this).addClass('active');
		$('.leaveJa').removeClass('show');
		$('.toJa').addClass('show');
	});

	$('.recruit__listItem').on('click', function () {
		$('.recruit__content').removeClass('show');
		const getId = $(this).attr('id');
		const openId = '#' + getId + '_info';
		console.log(openId);
		$(openId).addClass('show');
	});

	$('.faq__dt').on('click', function () {
		$(this).next('.faq__dd').addClass('show');
	});

	$(".manga__main").slick({
		arrows: false, // 矢印非表示
		asNavFor: ".manga__list", // サムネイルと同期

	});
	// サムネイルのオプション
	$(".manga__list").slick({
		slidesToShow: 4, // サムネイルの表示数
		asNavFor: ".manga__main", // メイン画像と同期
		focusOnSelect: true, // サムネイルクリックを有効化
	});


});
